import * as yup from 'yup';

export const codigoOTPFormSchema = yup.object({
  codigo: yup.string().required('El campo codigo es requerido'),

  telefono: yup.string().required('El campo telefono es requerido'),

  estado_recibido: yup
    .boolean()
    .typeError('El campo estado recibido es requerido')
    .required('El campo estado recibido es requerido'),

  enviado: yup
    .boolean()
    .typeError('El campo enviado es requerido')
    .required('El campo enviado es requerido'),

  prospecto: yup
    .number()
    .typeError('El campo prospecto es requerido')
    .optional()
    .nullable(),
});
